import PageTitle from '../components/CommonComps/Titles/PageTitle';
import SessionContainer from '../components/SessionComps/SessionContainer';
import SessionModalWrapper from '../components/SessionComps/SessionModalWrapper';
import SessionTimeReminder from '../components/SessionComps/SessionTimeReminder';
import SessionProvider from '../contexts/SessionProvider';

const Session = () => {
  // rendering session page component here
  return (
    <main className='font-lato relative flex items-center justify-center h-screen w-screen max-h-screen max-w-screen bg-base-dark-gray overflow-hidden'>
      <PageTitle title='Session' />
      <SessionProvider>
        <SessionContainer />

        <SessionTimeReminder />
        <SessionModalWrapper />
      </SessionProvider>
    </main>
  );
};

export default Session;
